import Brygady from './Brygady';
export default Brygady;